<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header>
    <card>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col>
                    <div class="card-wrapper">
                        <card>
                            <h2 class="mb-0">STATUS PENETAPAN GAJI PERMULAAN</h2>
                            <br />
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NAMA</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5">{{NamaPeribadi}}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NO KAD PENGENALAN</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5" class="col text-left">{{NoKP}}</b-col>
                                <!-- <b-button variant="default">Carian Pengguna</b-button> -->
                            </b-row>
                            <b-row>
                                <b-col sm="7">
                                    <b-form-group label="STATUS PENETAPAN GAJI PERMULAAN" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group variant="success" id="btn-radios-1" v-model="StatusPenetapanGaji2016" :options="options" :aria-describedby="ariaDescribedby" name="radios-stacked" stacked></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </card>
                    </div>
                </b-col>
            </b-row>
            <br />
            <div v-if="StatusPenetapanGaji2016 == 1">
                <validation-observer v-slot="{ invalid }">
                    <card header-classes="bg-transparent">
                        <h3 class="mb-0">**Maklumat Hanya Diisi Untuk Pegawai terlibat</h3>
                        <br />
                        <h3 class="mb-0">Penetapan Gaji Permulaan Gred 11, 13, 19 PPP1/2016</h3>
                        <br />
                        <div class="pl-lg-4">
                            <validation-provider name="SalGrdPertama" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3">Amaun Gaji Permulaan pada 1 Julai 2016 * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="ObjPenetepanGaji.Sal2016" :state="getValidation(validationContext)"></b-form-input>
                                    </b-col>
                                </b-row>
                            </validation-provider>

                            <b-col>&nbsp;</b-col>
                            <b-form-row>
                                <b-col>
                                    <b-form-group>
                                        <div>
                                            <b-col>&nbsp;</b-col>
                                            <b-col align="center">
                                                <b-button variant="success" type="submit" @click="simpan()" v-show="simpa2">SIMPAN</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button>

                                            </b-col>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </div>
                    </card>
                </validation-observer>
            </div>
            <div v-if="StatusPenetapanGaji2016 == 0">
                <card header-classes="bg-transparent">
                    <b-button size="md" variant="primary" @click="next()">SETERUSNYA</b-button>
                    <br />
                </card>
            </div>
        </b-container>
    </card>
</div>
</template>

<script>
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
export default {
    data() {
        return {
            form: {
                NoKP: "830512065661"
            },
            options: [{
                    text: 'YA',
                    value: '1'
                },
                {
                    text: 'TIDAK',
                    value: '0'
                }
            ],
            StatusPenetapanGaji2016: null,
            ObjPenetepanGaji: {},
            active: false,
            simpa2: true,
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },

        simpan() {
            this.ObjPenetepanGaji.StatusPenetapanGaji2016=this.StatusPenetapanGaji2016;
            this.$store.commit("addMaklPentapGaji", this.ObjPenetepanGaji);
            this.simpa2 = false;
            this.active = true;
            console.log(this.ObjPenetepanGaji);

        },

        next() {
            console.log(this.NoKP)
            this.$router.push({
                name: 'STATUS TUKAR LANTIK PP01/2016',

            })
        }
    },

    computed: {
        MaklumatPeribadiInStore() {
            return Store.state.MaklumatPeribadi;

            console.log("ini store", Store.state.MaklumatPeribadi);

        },

    },

    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        this.NamaPeribadi = this.$store.state.MaklumatPeribadi.Nama;
        this.NoKP = this.$store.state.MaklumatPeribadi.NoKP;

    }
}
</script>

<style>
h2 {
    text-decoration: underline;
}

.numbers {
    text-decoration: underline;
    text-decoration-color: white;
}
</style>
